import { createReducer } from '@reduxjs/toolkit';

import { DocusignEnvelope } from '@qwealth/qdata';

import { D2Envelope } from '../models/D2Envelope';
import {
  putDocusignEnvelopes,
  removeActiveDocusignEnvelope,
  putActiveDocusignEnvelope,
  putActiveDocusignEnvelopes,
  putRegistrationOnActiveEnvelope,
} from '../actions/docusignEnvelopes';

export interface IDocusignEnvelopesState {
  initialized: boolean;
  envelopes: Array<DocusignEnvelope>;
  envelope: DocusignEnvelope;
  activeEnvelopes: D2Envelope[];
}

const initialState: IDocusignEnvelopesState = {
  initialized: false,
  envelopes: [],
  envelope: {} as DocusignEnvelope,
  activeEnvelopes: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(putDocusignEnvelopes, (state, action) => ({
    ...state,
    initialized: true,
    envelopes: action.payload,
  }));
  builder.addCase(putActiveDocusignEnvelope, (state, action) => ({
    ...state,
    envelope: {
      ...state.envelope,
      ...action.payload,
    },
  }));
  builder.addCase(removeActiveDocusignEnvelope, state => ({
    ...state,
    initialized: true,
    envelope: {} as DocusignEnvelope,
  }));
  builder.addCase(putActiveDocusignEnvelopes, (state, action) => ({
    ...state,
    activeEnvelopes: action.payload,
  }));
  builder.addCase(putRegistrationOnActiveEnvelope, (state, action) => {
    const newRegistration = action.payload;
    const nbinRegistration = state.envelope.nbinRegistration ?? []
    const index = nbinRegistration.findIndex(registration => registration.id === newRegistration.id);
    if (index > -1) {
      nbinRegistration[index] = newRegistration;
    } else {
      nbinRegistration.push(newRegistration);
    }
    return state;
  });
});